import dayjs from 'dayjs'
import BriefcaseClock from '../../../../icons/BriefcaseClock'

const TicketsCard = (props) => {

  dayjs.locale('es')
  const formattedDate = dayjs(props?.date).format('dddd, D [de] MMMM')
  const formatHour = dayjs(props?.date).format('h:mma')

  return (
    <div className="border border-end-0 border-start-0 w-100 position-relative p-3">
      <div className="text-on-bg-primary  d-flex justify-content-start align-items-start gap-4">
        <div>
          <BriefcaseClock />
        </div>
        <div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <span className="fw-bolder">{props?.type_ticket?.name}</span>

            <span>{formatHour}</span>
          </div>

          <div className="d-flex align-items-center gap-1">
            <span className="fw-bolder">Empresa:</span>
            <span>{props?.name}</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <span className="fw-bolder">Correo:</span>
            <span>{props?.contact_email}</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <span className="fw-bolder">Teléfono:</span>
            <span>{props?.additional_information}</span>
          </div>
        </div>
      </div>
      <div className=" d-flex justify-content-center align-items-center">
        <span className="position-absolute top-0 p-2 border rounded border-on-bg-Tertiary text-on-bg-secondary mt-2">
          {formattedDate}
        </span>
      </div>
    </div>
  )
}

export default TicketsCard
